
import mixin from './mixin'
import CourseCard from '@pui/CourseCard'

export default {
  mixins: [mixin],

  render () {
    const {
      list, // from mixin
      title, // from mixin
      style, // from mixin
      onClick // from mixin
    } = this

    return (
      <section class={style.block}>
        <h2 class={style.title}>{title}</h2>
        <ul class={style.floatBox}>
          {
            list.map(item => (
              <li class={style.floatItem} onClick={() => onClick(item)}>
                <CourseCard dataSource={item} />
              </li>
            ))
          }
        </ul>
      </section>
    )
  }
}
